import { styled } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';
import { FONT_BRIGHTNESS } from '@hivebrite/design-system/Theme';

export const RecommendedContentCardSkeleton = () => (
  <Wrapper data-testid="content-recommendation-item-skeleton" mb={5}>
    <Skeleton height={{ _: '128px', m: '69px' }} width={{ m: '186px' }} />
    <Box flex={1} flexDirection="column" ml={{ m: 6 }} p={{ _: 4, m: 0 }}>
      <Skeleton height={20} width={60} />
      <Skeleton height={20} mb={1} mt={2} width="70%" />
      <Skeleton height={20} width="100%" />
    </Box>
  </Wrapper>
);

const Wrapper = styled(Box).attrs({
  p: { _: 0, m: 4 },
  minHeight: { _: '163px', m: '145px' },
  flexDirection: { _: 'column', m: 'row' },
  alignItems: { m: 'center' },
  justifyContent: { m: 'center' },
})`
  border: 1px solid
    ${({ theme }) => {
      if (theme.themeVariables.fontBrightness === FONT_BRIGHTNESS.LIGHT) {
        return theme.colors.snow;
      }

      return theme.colors.horizon;
    }};
  border-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
`;
